import { useEffect } from 'react';
import { useMatch } from 'react-router-dom';

import { usePreviousState } from '@ajaibid/hooks';
import useLayout from '@context/layout/useLayout';

export default function useTradePanelAutoShow() {
  const { tradePanel } = useLayout();

  const isMatchSDP = useMatch('/home/saham/:code');
  const previousIsMatchSDP = usePreviousState(isMatchSDP);

  useEffect(() => {
    if (previousIsMatchSDP === isMatchSDP) {
      return;
    }
    if (isMatchSDP) {
      tradePanel.show();
    } else {
      tradePanel.hide();
    }
  }, [isMatchSDP, tradePanel]);
}
